

export function buildConfirmResendInfo(numOfAnmodning, actionType, resendFlag) {
    let infoTxt = [];

    if (!numOfAnmodning) {
        infoTxt.push("Fejl ingen anmodninger angivet");
        return infoTxt;
    } 

    infoTxt.push('Er du sikker på at du vil:')

    switch (actionType) {
        case 'restart':
             infoTxt.push(numOfAnmodning > 1 ? 'Hente data igen på disse anmodninger.' : 'Hente data igen på denne anmodning.');
            break;
        case 'transform':
            infoTxt.push(numOfAnmodning > 1 ? 'Oversætte til LER-modellen på disse anmodninger.' : 'Oversætte til LER-modellen på denne anmodning.');
            break;            
        case 'send':
            infoTxt.push(numOfAnmodning > 1 ? 'Sende disse anmodninger til LER' : 'Sende denne anmodning til LER');
            break;  
        case 'quickfix':
            infoTxt.push(numOfAnmodning > 1 ? 'Tilbagedatere fejl på disse anmodninger.' : 'Tilbagedatere fejl på denne anmodning.');
            break;
        case 'markasmanuelhaandt':
            infoTxt.push(numOfAnmodning > 1 ? 'Markére disse anmodninger som færdigbehandlet. Vær opmærksom på at der ikke sendes ledningsoplysninger til graveaktøren igennem LER2' : 'Markére denne anmodning som færdigbehandlet. Vær opmærksom på at der ikke sendes ledningsoplysninger til graveaktøren igennem LER2');
            break;
        case 'sendmanuelmedoplysninger':
            infoTxt.push(numOfAnmodning > 1 ? 'Sende ledningsoplysninger manuelt.' : 'Sende ledningsoplysninger manuelt.');
            break;
        default:
    }
    
    if (numOfAnmodning > 1) {
        infoTxt.push( `${numOfAnmodning} anmodninger valgt`);
    }
   
    if (resendFlag){
        infoTxt.push('Bemærk: Der sendes ny LER pakke!');
    }
    return infoTxt;
}